import { IFilter } from "@saleor/components/Filter";
import { FilterOpts } from "@saleor/types";
import { createBooleanField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum SubscriberFilterKeys {
  active = "active"
}

export interface SubscriberListFilterOpts {
  active: FilterOpts<boolean>;
}

const messages = defineMessages({
  status: {
    defaultMessage: "Subscribed",
    description: "When Subscriber active"
  },
  active: {
    defaultMessage: "Active"
  },
  inactive: {
    defaultMessage: "Inactive"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: SubscriberListFilterOpts
): IFilter<SubscriberFilterKeys> {
  return [
    {
      ...createBooleanField(
        SubscriberFilterKeys.active,
        intl.formatMessage(messages.status),
        opts.active.value,
        {
          negative: intl.formatMessage(messages.inactive),
          positive: intl.formatMessage(messages.active)
        }
      ),
      active: opts.active.active
    }
  ];
}
